import { useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";

let cache = null;
const listeners = new Set();

export function useContents() {
  const [contents, setContents] = useState(cache || {});
  useEffect(() => {
    if (cache) return;
    api("/contents")
      .then((d) => { cache = d; listeners.forEach((fn) => fn(d)); })
      .catch(() => {});
    listeners.add(setContents);
    return () => listeners.delete(setContents);
  }, []);
  const c = useCallback((key, fallback) => contents[key] || fallback, [contents]);
  return c;
}

export function invalidateContents() { cache = null; }
